import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowLoopDownLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowLoopDownLeft"><Path d="M12.5 3C16.6421 3 20 6.35786 20 10.5V11C20 14.866 16.866 18 13 18V16.5C16.0376 16.5 18.5 14.0376 18.5 11V10.5C18.5 7.18629 15.8137 4.5 12.5 4.5C9.18629 4.5 6.5 7.18629 6.5 10.5V18.4395L9.5 15.4395L10.5605 16.5L5.75 21.3105L0.939453 16.5L2 15.4395L5 18.4395V10.5C5 6.35786 8.35787 3 12.5 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowLoopDownLeft;
